import DollarIcon from "@/assets/icons/Finance/dollar 1.svg?react";
import { Typography } from "@st-marketplace/ui";
import type { ReactNode } from "react";

interface DashboardLayoutHeaderPlatformCurrencyProps {
	label: string;
	amount: string;
	caption?: string;
	compact?: boolean;
	/** Optional action rendered next to the amount, e.g. "pay this off". */
	action?: ReactNode;
}

function DashboardLayoutHeaderPlatformCurrency({
	amount,
	label,
	caption,
	compact = false,
	action,
}: DashboardLayoutHeaderPlatformCurrencyProps) {
	if (compact) {
		return (
			<div className="flex min-w-0 flex-1 items-center gap-2 px-3 py-2.5">
				<span className="shrink-0 text-primary-fill [&>svg]:size-5">
					<DollarIcon />
				</span>
				<div className="min-w-0">
					<Typography
						variant="caption"
						className="block truncate text-secondary-text-100"
					>
						{label}
					</Typography>
					<div className="flex items-baseline gap-1.5">
						<Typography
							variant="body-sm"
							className="font-semibold tabular-nums text-secondary-text"
						>
							{amount}
						</Typography>
						{caption && (
							<Typography
								variant="caption"
								className="truncate text-secondary-icon"
							>
								{caption}
							</Typography>
						)}
					</div>
				</div>
				{action ? (
					<span className="ms-auto shrink-0 ps-2">{action}</span>
				) : null}
			</div>
		);
	}

	return (
		<div className="flex min-w-48 items-center gap-3 px-4 py-2.5">
			<span className="shrink-0 text-primary-fill [&>svg]:size-5">
				<DollarIcon />
			</span>
			<div className="min-w-0 flex-1">
				<div className="flex items-baseline gap-1 whitespace-nowrap">
					<Typography variant="caption" className="text-secondary-text-100">
						{label}
					</Typography>
					{caption && (
						<Typography variant="caption" className="text-secondary-icon">
							{caption}
						</Typography>
					)}
				</div>
			</div>
			<Typography
				variant="body-sm"
				className="shrink-0 font-semibold tabular-nums text-secondary-text"
			>
				{amount}
			</Typography>
			{action ? <span className="ms-2 shrink-0">{action}</span> : null}
		</div>
	);
}

export default DashboardLayoutHeaderPlatformCurrency;
